module.exports = __webpack_public_path__ + "static/media/stubborntrader.fa08b49b.png";